'use client';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

interface BrandProductsLinkProps {
  href: string;
  label: string;
  brandLabel: string;
  className?: string;
  childrenClassName?: string;
}

export function BrandProductsLink({
  href,
  label,
  className,
  childrenClassName
}: BrandProductsLinkProps) {
  return (
    <UiKitButtonBase
      className={className}
      childrenClassName={childrenClassName}
      as="link"
      href={href}
      color="ghost"
    >
      {label}
      <ArrowIcon />
    </UiKitButtonBase>
  );
}
